import { useCallback } from 'react';
import { useToken } from './useToken';
import axios from 'axios';

export const useProductCategoryDescriptionSet = (id : any) => {

  const token = useToken();

  return useCallback((description) =>
      axios
        .post(`${process.env.REACT_APP_SERVER_URL}/categories/set-description/${id}`,
          {description: description},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
    , [token]);
};